import { render, staticRenderFns } from "./modificheAmmesseProdotti.vue?vue&type=template&id=73205dbd&"
import script from "./modificheAmmesseProdotti.vue.ts?vue&type=script&lang=ts&"
export * from "./modificheAmmesseProdotti.vue.ts?vue&type=script&lang=ts&"
import style0 from "./modificheAmmesseProdotti.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports